var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("TableScrollSlider", {
        attrs: { "table-ref": _vm.$refs.multipleTable },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("任务管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageSerch" },
          [
            _c(
              "el-card",
              { staticClass: "box-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "cardTitle" }, [
                      _vm._v("任务列表"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "任务名称" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入任务名称",
                                  },
                                  model: {
                                    value: _vm.ruleForm.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "name", $$v)
                                    },
                                    expression: "ruleForm.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "发布人姓名" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入发布人名",
                                  },
                                  model: {
                                    value: _vm.ruleForm.creator_name,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "creator_name",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.creator_name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "发布人手机号" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入发布人手机号",
                                  },
                                  model: {
                                    value: _vm.ruleForm.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "phone", $$v)
                                    },
                                    expression: "ruleForm.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "任务编号" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入任务编号",
                                  },
                                  model: {
                                    value: _vm.ruleForm.jobNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "jobNo", $$v)
                                    },
                                    expression: "ruleForm.jobNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "任务状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择任务状态" },
                                    model: {
                                      value: _vm.ruleForm.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "status", $$v)
                                      },
                                      expression: "ruleForm.status",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "待支付", value: "0" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "待发布", value: "1" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "发布中", value: "2" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "已收单", value: "3" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "实做中", value: "4" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "已取消", value: "5" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "已结算", value: "6" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "已关闭", value: "9" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("el-form-item", { attrs: { label: "时间" } }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "datetime",
                                      placeholder: "选择开始时间",
                                      align: "right",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                    },
                                    model: {
                                      value: _vm.ruleForm.time,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "time", $$v)
                                      },
                                      expression: "ruleForm.time",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { margin: "0 5px" } },
                                    [_vm._v("-")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "datetime",
                                      placeholder: "选择结束时间",
                                      align: "right",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                    },
                                    model: {
                                      value: _vm.ruleForm.time1,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "time1", $$v)
                                      },
                                      expression: "ruleForm.time1",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "支付状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择支付状态" },
                                    model: {
                                      value: _vm.ruleForm.cadeVerifyStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "cadeVerifyStatus",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.cadeVerifyStatus",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "待支付", value: "0" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "已支付", value: "1" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getList()
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.exportList(1)
                  },
                },
              },
              [_vm._v("任务excel导出")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.exportList(2)
                  },
                },
              },
              [_vm._v("实做人员明细导出")]
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%", "margin-top": "20px" },
                attrs: { data: _vm.tableData, "tooltip-effect": "dark" },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "jobNo",
                    label: "单号",
                    align: "center",
                    width: "200",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "creatorName",
                    label: "发布人",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "任务名称", align: "center", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-popover",
                            { attrs: { trigger: "hover", placement: "top" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.title) +
                                  "\n              "
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "name-wrapper",
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _c("div", { staticClass: "omit" }, [
                                    _vm._v(_vm._s(scope.row.title)),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "phone",
                    label: "发布人手机号",
                    align: "center",
                    width: "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "belongCompanyName",
                    label: "归属",
                    align: "center",
                    width: "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "服务时长", align: "center", width: "80" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-popover",
                            { attrs: { trigger: "hover", placement: "top" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.jobStart) + "至"),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(scope.row.jobEnd))]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "name-wrapper",
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _c("div", { staticClass: "omit" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("maxTime")(scope.row.hour * 60)
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "任务时间", align: "center", width: "190" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [_vm._v(_vm._s(scope.row.jobStart))]),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(scope.row.jobEnd))]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "总金额", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              "￥" +
                                _vm._s(_vm._f("moneyFormat")(scope.row.price))
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "申请人", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.readiesNum) + "/"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(scope.row.membersNum))]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "创建时间", align: "center", width: "190" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [_vm._v(_vm._s(scope.row.gmtCreate))]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "状态", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.status == 0
                            ? _c("span", { staticClass: "yellowColor" }, [
                                _vm._v("待支付"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 1
                            ? _c("span", { staticClass: "blueColor" }, [
                                _vm._v("待发布"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 2
                            ? _c("span", { staticClass: "blueColor" }, [
                                _vm._v("发布中"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 3
                            ? _c("span", { staticClass: "blueColor" }, [
                                _vm._v("已收单"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 4
                            ? _c("span", { staticClass: "blueColor" }, [
                                _vm._v("实做中"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 5
                            ? _c("span", { staticClass: "redColor" }, [
                                _vm._v("已取消"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 6
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("已结算"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 8
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("已完成"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 9
                            ? _c("span", { staticClass: "redColor" }, [
                                _vm._v("已关闭"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "结算状态", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.cashType == 0
                            ? _c("span", { staticClass: "blueColor" }, [
                                _vm._v("未结算"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.cashType == 1
                            ? _c("span", { staticClass: "blueColor" }, [
                                _vm._v("结算中"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.cashType == 2
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("已结算"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "支付方式", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.payWay == 0
                            ? _c("span", [_vm._v("钱包")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.payWay == 2
                            ? _c("span", [_vm._v("银行卡")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.payWay == 3
                            ? _c("span", [_vm._v("支付宝")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.payWay == 4
                            ? _c("span", [_vm._v("微信")])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "退款状态", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.refundStatus == 0
                            ? _c("span", [_vm._v("无退款")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.refundStatus == 1
                            ? _c("span", { staticClass: "blueColor" }, [
                                _vm._v("处理中"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.refundStatus == 2
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("已完成"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "refundAt",
                    label: "退款时间",
                    align: "center",
                    width: "150",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "支付状态", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.payStatus == 0
                            ? _c("span", { staticClass: "yellowColor" }, [
                                _vm._v("待支付"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.payStatus == 1
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("已支付"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "操作",
                    align: "center",
                    fixed: "right",
                    width: "160",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "disAround" }, [
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.goDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("详情")]
                            ),
                            _vm._v(" "),
                            scope.row.status == 2 ||
                            (scope.row.status == 4 &&
                              scope.row.members_num > scope.row.readies_num)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEdit(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                派单\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.status == 4 || scope.row.status == 6
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.goDetail1(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                实做详情\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.pageSize,
                layout: "total, prev, pager, next,sizes",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "派单设置",
            visible: _vm.dialogFormVisible1,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible1 = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "ruleForm", attrs: { model: _vm.ruleForm2 } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 4 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入名称" },
                            on: { focus: _vm.clearData },
                            model: {
                              value: _vm.ruleForm2.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm2, "name", $$v)
                              },
                              expression: "ruleForm2.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入手机号" },
                            on: { focus: _vm.clearData },
                            model: {
                              value: _vm.ruleForm2.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm2, "phone", $$v)
                              },
                              expression: "ruleForm2.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "身份状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.ruleForm2.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm2, "status", $$v)
                                },
                                expression: "ruleForm2.status",
                              },
                            },
                            _vm._l(_vm.tableData2, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.getUserList()
                                },
                              },
                            },
                            [_vm._v("查询")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm1()
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
            _vm._v("搜索总数：" + _vm._s(_vm.tableData1.length)),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              ref: "singleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData1,
                "highlight-current-row": "",
                "max-height": "250",
              },
              on: { "current-change": _vm.selectItem },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", width: "50" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", {
                          class: [
                            scope.row.id == _vm.selectUserID
                              ? "select"
                              : "noselect",
                          ],
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "姓名" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.accountType == 0
                              ? scope.row.companyName
                              : scope.row.cardName
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.accountType == 0
                              ? "企业"
                              : scope.row.accountType == 1
                              ? "企业员工"
                              : "临勤"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "30px", "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.allocation()
                    },
                  },
                },
                [_vm._v("派单")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.resetForm2()
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }